var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mx-auto mb-6 google-sign-in-btn",on:{"click":_vm.googleSignIn}},[_c('img',{attrs:{"height":"20","width":"20","src":require("../../../public/google-logo.svg")}}),_vm._v(" Link Google Account To Verify ")])
}
var staticRenderFns = []

export { render, staticRenderFns }